let tableDidMount = false

/**
 * Fallback table style if no data has been passed in to configure a real table
 */
function simpleTable (zoneId) {
  const ticketSelector = '.tn-ticket-selector__pricetype-label-container'

  if ($(ticketSelector).length > 0) {
    if (tableDidMount === false) {
      $('.tn-ticket-selector__pricetype-list').addClass('js-wrapperTable')
      const targetElement = (`.tn-ticket-selector__pricetype-container[data-zone-id="${zoneId}"]:not(:has(.js-tableHeader)`);
      console.log(targetElement)
      document.querySelector(targetElement).insertAdjacentHTML('afterbegin', '<div class="js-tableHeader">Tickets</div>');
      $('.tn-ticket-selector__pricetype-list-item').addClass("js-wrapperRow")
      $('.js-wrapperRow').each(function () {
        const str = $(this).html()
        const match = str.match(/(£\s*[0-9,]+(?:\s*\.\s*\d{2})?)/g)
        // console.log(match[0])
        $(this).find('.tn-ticket-selector__pricetype .tn-ticket-selector__amount-input-container').prepend('<span class="js-priceType">' + match[0] + '</span>')
      })
    }

    tableDidMount = true
  }
}

export default simpleTable
